// frontend/src/services/whatsNewService.js
// CODEX_PROMPT_88 : lecture publique de la section "Quoi de neuf".
// Recupere en parallele la ligne de reglages (whats_new_settings id = 1) et les
// cartes publiees (whats_new_cards). Retourne null sur erreur pour que le
// composant retombe sur le contenu statique de whatsNew.js (fallback reseau).
import { supabase } from '../lib/supabase';

const CARDS_TABLE = 'whats_new_cards';
const SETTINGS_TABLE = 'whats_new_settings';

/**
 * Recupere le contenu dynamique de la section "Quoi de neuf".
 * @returns {Promise<{ settings: Object|null, cards: Array<Object> } | null>}
 *   null en cas d'erreur (le composant utilise alors le fallback statique).
 */
export async function fetchWhatsNewContent() {
  try {
    const [settingsRes, cardsRes] = await Promise.all([
      supabase.from(SETTINGS_TABLE).select('*').eq('id', 1).maybeSingle(),
      supabase
        .from(CARDS_TABLE)
        .select('*')
        .eq('is_published', true)
        .order('sort_order', { ascending: true })
        .order('created_at', { ascending: true }),
    ]);

    if (settingsRes.error || cardsRes.error) {
      // eslint-disable-next-line no-console
      console.warn(
        '[whatsNewService] fetchWhatsNewContent failed, using static fallback',
        settingsRes.error?.message || cardsRes.error?.message
      );
      return null;
    }

    return {
      settings: settingsRes.data || null,
      cards: Array.isArray(cardsRes.data) ? cardsRes.data : [],
    };
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[whatsNewService] unexpected error, using static fallback', err?.message);
    return null;
  }
}
